var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCity(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 17,
    viewBox: "0 0 16 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Building"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M13.4444 0.5H5.66667C4.80878 0.5 4.11111 1.2176 4.11111 2.1V6.9H2.55556C1.69767 6.9 1 7.6176 1 8.5V15.7C1 15.9122 1.08194 16.1157 1.22781 16.2657C1.37367 16.4157 1.5715 16.5 1.77778 16.5H14.2222C14.4285 16.5 14.6263 16.4157 14.7722 16.2657C14.9181 16.1157 15 15.9122 15 15.7V2.1C15 1.2176 14.3023 0.5 13.4444 0.5ZM2.55556 8.5H7.22222V14.9H2.55556V8.5ZM13.4444 14.9H8.77778V8.5C8.77778 7.6176 8.08011 6.9 7.22222 6.9H5.66667V2.1H13.4444V14.9Z",
    fill: "#727190"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M7.2 3.5H8.8V5.09984H7.2V3.5ZM10.4 3.5H12V5.09984H10.4V3.5ZM10.4 6.72448H12V8.29952H10.4V6.72448ZM10.4 9.89936H12V11.4992H10.4V9.89936ZM4 9.90016H5.6V11.5H4V9.90016Z",
    fill: "#727190"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCity);
export default __webpack_public_path__ + "static/media/city.a850c76b098f64f74ff36854bb2a787a.svg";
export { ForwardRef as ReactComponent };